import { AUTH } from '../types/authTypes';

const initialState = {
  isloggedIn: false,
};

let auth = (state = initialState, action) => {
  switch (action.type) {
    case AUTH.LOGIN:
      return {
        ...action.data,
      };
    case AUTH.LOGOUT:
      return { ...initialState }
    default:
      return state;
  }
};

export default auth;
